import { ChangeEvent, useState } from 'react'
import { MaybeBoolean } from '../../../../../utils/types/types'
import { useFieldProps } from '../../../../../hooks'
import { ContactInformationRelease } from '../../../../../utils/classes/graphql'
import { Checkbox, CheckboxProps } from '../../../../../components'

interface OwnInfoCheckBoxProps
  extends Pick<CheckboxProps, 'disabled' | 'label'> {
  name: string
}

export const OwnInfoCheckBox = ({
  name,
  disabled,
  label
}: OwnInfoCheckBoxProps) => {
  const { setValue, value } = useFieldProps<ContactInformationRelease>(name)

  const [checked, setChecked] = useState(value.valinta || false)

  const handleChange = (
    _event: ChangeEvent<HTMLInputElement>,
    selected: MaybeBoolean
  ) => {
    if (selected == null) {
      selected = false
    }
    setChecked(selected)
    setValue({
      ...value,
      valinta: selected
    })
  }

  return (
    <Checkbox
      checked={checked}
      disabled={disabled}
      label={label}
      onChange={handleChange}
    />
  )
}
